export enum SinBinSystem {
    none = "none",
    systemA = "systemA",
    systemB = "systemB",
    systemB2024 = "systemB2024",
}
